export {};

const active = 'active';
const onResizeCallbacks = [];

$(init);

NLMK.initFilters = init;

function init() {
    $(window).on(
        'resize',
        $.debounce(100, function onResize() {
            onResizeCallbacks.forEach((callback) => callback());
        }),
    );

    $('.filter').each(eachFilter);
}

function eachFilter(filterIndex, Filter) {
    const $filter = $(Filter);

    if ($filter.data('filter-init')) {
        return true;
    }

    $filter.data('filter-init', true);

    const $highlight = $('<div class="filter__highlight"></div>');
    const $scale = $('<div class="filter__scale"></div>');
    const $list = $filter.find('.filter__list');
    const $items = $list.find('.filter__item');

    $scale.css(
        "min-width", $list.innerWidth()
    );

    $filter.append($highlight);
    $filter.append($scale);

    $list.on('click', '.filter__link', (evt) => {
        $(evt.currentTarget)
            .closest('.filter__item')
            .addClass(active)
            .siblings()
            .removeClass(active);

        highlight();

        if ('A' === evt.currentTarget.tagName) {
            evt.preventDefault();
        }
    });

    highlight();

    onResizeCallbacks.push(highlight);

    function highlight() {
        const $activeItem = $items.filter('.active');

        const translateX = $activeItem.offset().left - $filter.offset().left;

        $highlight.css({
            transform: `translateX(${translateX}px)`,
            width: $activeItem.width(),
        });
    }
}



// WEBPACK FOOTER //
// ./js/main/module/filter.js